import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const stats = [
  { number: '2,400+', label: 'Items Reused', icon: 'ri-shirt-line', color: '#F5B730' },
  { number: '380+', label: 'Families Helped', icon: 'ri-team-line', color: '#3DBD8A' },
  { number: '1,200kg', label: 'CO₂ Saved', icon: 'ri-leaf-line', color: '#8A6FD8' },
];

export default function About() {
  return (
    <div style={{ fontFamily: "'Nunito', sans-serif" }}>
      <Navbar />

      <section className="relative pt-28 pb-20 overflow-hidden" style={{ backgroundColor: '#F5F2FD' }}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col lg:flex-row gap-14 items-center">
            <div className="flex-1">
              <span className="text-brand-purple text-xs font-600 uppercase tracking-widest" style={{ fontWeight: 600 }}>• Our Story</span>
              <h1
                className="text-4xl md:text-5xl font-700 text-gray-800 mt-3 mb-6 leading-tight"
                style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}
              >
                Closing the Loop on
                <br />
                <em className="not-italic text-brand-yellow">Sustainable Kids Fashion</em>
              </h1>
              <p className="text-gray-500 leading-relaxed mb-4">
                Little Loop was born in 2021 from a simple but powerful idea: second-hand kids clothing and used toys deserve a second chance. We are a family-owned thrift shop in Beloeil, QC, specializing in pre-owned clothing and toys for children ages 1 to 12.
              </p>
              <p className="text-gray-500 leading-relaxed mb-4">
                Our founder, Isaac Salaverry Marín, started with a box of her own kids&apos; clothes and a belief that there had to be something better than throwing out perfectly good items. Today, <strong>Little Loop</strong> is a gathering place for families who want quality clothing for their kids without overspending, while also reducing the environmental impact of the fashion industry.
              </p>
              <p className="text-gray-500 leading-relaxed">
                Every garment and toy that comes through our doors is inspected, cleaned, and sorted with care before finding a new home — because at Little Loop we believe that sustainable can also be beautiful, affordable, and fun.
              </p>
            </div>

            <div className="flex-shrink-0 lg:w-[302px]">
              <div className="relative rounded-3xl overflow-hidden" style={{ height: '346px' }}>
                <img
                  src="https://storage.readdy-site.link/project_files/6541567e-6f9e-4c0d-a197-6ac1391c9a7a/7175b1ac-5302-4017-a9ed-1dde90f7298a_ChatGPT-Image-Mar-23-2026-09_30_33-PM.png?v=ec368696024e9f4b0aa865da0ecc43c4"
                  alt="Isaac Salaverry Marín - Founder of Little Loop"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute bottom-0 left-0 right-0 p-5" style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.55) 0%, transparent 100%)' }}>
                  <p className="text-white font-700 text-lg" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}>Isaac Salaverry Marín</p>
                  <p className="text-white/80 text-sm">Founder, Little Loop</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <div className="bg-brand-yellow-pale rounded-3xl p-10">
            <i className="ri-double-quotes-l text-5xl text-brand-yellow block mb-4"></i>
            <p className="text-2xl text-gray-700 leading-relaxed mb-6" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 600 }}>
              Our mission is to give every garment and toy a second life, supporting families with affordable and sustainable options for their children.
            </p>
            <div className="flex items-center justify-center gap-3">
              <img
                src="https://storage.readdy-site.link/project_files/6541567e-6f9e-4c0d-a197-6ac1391c9a7a/110f37e5-96e8-4c69-ac75-99d73641fb18_410-DP3---2.png?v=ad04a06fe90851ea0575a478e492e2f4"
                alt="Little Loop Logo"
                className="w-12 h-12 object-contain flex-shrink-0"
              />
              <div className="text-left">
                <p className="font-700 text-gray-800 text-sm" style={{ fontWeight: 700 }}>Isaac Salaverry Marín</p>
                <p className="text-xs text-gray-400">Founder of Little Loop</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16" style={{ backgroundColor: '#FAFAFA' }}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-700 text-gray-800" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}>Our Impact</h2>
            <p className="text-gray-400 mt-2 text-sm">Every purchase makes a difference</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {stats.map(s => (
              <div key={s.label} className="bg-white rounded-2xl p-8 text-center">
                <div className="flex items-center justify-center w-16 h-16 rounded-full mx-auto mb-4" style={{ backgroundColor: s.color + '22' }}>
                  <i className={`${s.icon} text-3xl`} style={{ color: s.color }}></i>
                </div>
                <p className="text-4xl font-700 mb-2" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700, color: s.color }}>{s.number}</p>
                <p className="text-sm text-gray-500 font-500" style={{ fontWeight: 500 }}>{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-3xl font-700 text-gray-800 text-center mb-12" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}>
            Our Values
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { icon: 'ri-recycle-line', title: 'Sustainability', description: 'We believe in the circular economy. Every item we reuse is one less step toward the landfill and one more step toward a healthier planet.', color: '#3DBD8A' },
              { icon: 'ri-heart-3-line', title: 'Community', description: 'We are part of our local community. We support families of all economic backgrounds so their children are always well-dressed.', color: '#F5B730' },
              { icon: 'ri-shield-check-line', title: 'Quality Guaranteed', description: 'We inspect and select every item we sell. We only carry products in Excellent, Very Good, or Good condition.', color: '#8A6FD8' },
            ].map(v => (
              <div key={v.title} className="rounded-2xl p-6" style={{ backgroundColor: v.color + '11' }}>
                <div className="flex items-center justify-center w-12 h-12 rounded-xl mb-4" style={{ backgroundColor: v.color + '22' }}>
                  <i className={`${v.icon} text-2xl`} style={{ color: v.color }}></i>
                </div>
                <h3 className="font-700 text-gray-800 mb-2" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}>{v.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{v.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
